<template>
  <div>
    <BigArmyLoading :value="!loaded">
    <div v-if="invitationExpired" class="invitationExpiredWrapper">
      <div>
        <img src="@/assets/noposter.png" class="img">
        <div class="text-wrapper">
          <div class="text">当前页面已失效，</div>
          <div class="text">请联系分享人获取最新的邀请码。</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="topselect">
        <div class="topselect-item" @click="changeType(1)" :class="index == 1 ? 'active' : ''">
          账密授权
        </div>

        <div class="topselect-item" @click="changeType(2)" :class="index == 2 ? 'active' : ''">
          扫码授权
        </div>
        <div class="topselect-item" @click="changeType(3)" :class="index == 3 ? 'active' : ''">
          代理授权
        </div>
      </div>
      <left v-show="index == 1" ref="leftRef" :info="companyInfo" :aName="appTypeName"
            :jzm="validateMethod" :pId="programId" :icd="isChecked" :idm="isDemo"></left>
      <QrAuthorize from="2rd" :disableCompanyChange="true" v-if="index == 2" :info="companyInfo"
                   :aName="appTypeName" :jzm="validateMethod" :pId="programId" :icd="isChecked"
                   :idm="isDemo" :skuId="skuId"></QrAuthorize>
      <right v-show="index == 3" ref="rightRef" :info="companyInfo" :aName="appTypeName"
             :jzm="validateMethod" :pId="programId" :icd="isChecked" :idm="isDemo"></right>
    </div>
    </BigArmyLoading>

  </div>
</template>
<script>
import left from "./left.vue";
import right from "./right.vue";
import {isJSON} from "@/utils/helper.js"

import {
  getAuthToken,
  savePrepareFromSecond,
  savePrepare,
  getPrepareInfo,
  getSharedPrepareInfo
} from "@/api/openNew.js";

import {cloneDeep} from "lodash";
import QrAuthorize from "@/pages/openNew/QrAuthorize.vue";
import BigArmyLoading from "@/components/BigArmyLoading.vue";

export default {
  components: {
    BigArmyLoading,
    QrAuthorize,
    left,
    right,
  },
  data() {
    return {
      loaded:false,
      index: 1,
      skuId: null,
      companyInfo: {
        companyName: "",
        userName: "",
        userCode: "",
        password: "",
        identityType: 3,
        phoneNumber: "",
      },
      invitationExpired:0, //0 未初始化 1 已过期
      infos: {},
      appTypeName: "",
      validateMethod: 1, //验证方式 1密码 2验证码
      programId: "",
      isChecked: false,
      isDemo: undefined,
      haveload: false
    };
  },
  async mounted() {
    this.loaded=false
    this.skuId = this.$route.query.skuId
    if (this.$route.query.tab) {
      this.index = Number(this.$route.query.tab);
    }

    window && window.parent && window.parent.postMessage("Ready", "*");


    window.addEventListener("message", this.receiveMsg, false);


    //三方授权
    if (this.$route.name == "oemGuardV4") {

      let accessToken = this.$route.query.accessToken;
      localStorage.setItem("accessToken", accessToken);
      //获取三方授权信息并保存
      await this.savePrepareApi();
    } else if (this.$route.name == "oemGuardV4_3") {
      //如果是二方邀请页面则，从接口获取信息并保存在本地

      const params = {
        uniqueCode: this.$route.query.uniqueCode,
      };
      const res = await getSharedPrepareInfo(params);
      if (res.status == 200) {
        localStorage.setItem(
          "share-accessToken",
          res.headers["share-accesstoken"]
        );
        if (res.data.code == 200) {
          this.infos = cloneDeep(res.data.data)

          this.appTypeName = res.data.data.appTypeName;
          this.companyInfo.companyName = res.data.data.companyName;
          this.companyInfo.agentTaxNo = res.data.data.taxNo;
          this.companyInfo.userName = res.data.data.taxNo;
          this.programId = res.data.data.programId;
          this.validateMethod = res.data.data.validateMethod;
        }else if (res.data.code ==5050){
          this.invitationExpired=1
        }
      }
    }
    this.loaded=true
  },
  methods: {
    async savePrepareApi() {
      // this.str = encodeURIComponent(this.$route.query.redirect_uri)
      this.str = this.$route.query.redirect_uri
      const params = {
        state: this.$route.query.state,
        skuId: this.$route.query.skuId,
        redirectUri: decodeURIComponent(this.str)
        // redirectUri:decodeURIComponent(this.$route.query.redirect_uri)
      }
      const res = await savePrepare(params)
      if (res.code == 200) {
        this.programId = res.data.programId
      }

    },
    async saveCompanny(e) {

      const params = {
        programId: e.programId || '',
        taxNo: e.companyNo,
        companyName: e.companyName,
        startDate: e.startYear,
        endDate: e.endYear,
        appTypeName: this.appTypeName,
        remainDays: e.remainDays ? e.remainDays : ''
      }
      if (this.appTypeName == 'lvat' || this.appTypeName == 'eit') {
        params.state = JSON.stringify({projectId: this.getInfo.projectId || ''})
      }
      const res = await savePrepareFromSecond(params)
      if (res.code == 200) {
        this.programId = res.data.programId
        const params = {
          messageInfo: 'setProgramId',
          value: this.programId
        }
        window.parent && window.parent.postMessage(JSON.stringify(params), "*");

      }

    },
    async getToken(e) {
      const params = {
        appTypeName: this.appTypeName,
        authorization: e,
      };
      const res = await getAuthToken(params);
      if (res.code == 200) {
        localStorage.setItem("accessToken", res.data.accessToken);
      }
    },
    async receiveMsg(e, isfirst = true) {
      if (isJSON(e.data)) {
        let info = JSON.parse(e.data);

        if (info.messageInfo == "setMessage") {
          if (this.haveload) {
            return
          }

          if (isfirst) {
            this.infos = cloneDeep(info)

          }
          this.getInfo = info;
          this.appTypeName = info.appTypeName;
          this.companyInfo.companyName = info.companyName;
          this.programId = info.programId || this.programId;
          this.isDemo = info.isDemo || false;
          if (this.index == 1) {
            this.companyInfo.userName = info.companyNo;
            delete this.companyInfo.agentTaxNo
          } else {
            this.companyInfo.agentTaxNo = info.companyNo;
            this.companyInfo.userName = '';

          }

          if (isfirst) {
            await this.getToken(info.authorization);

            await this.saveCompanny(info);
          }

          const res = await getPrepareInfo({programId: this.programId});
          if (res.code == 200) {
            this.validateMethod = res.data.validateMethod;
          }
          this.haveload = true;

        }
      } else {
        if (e.data == "message") {
          this.isChecked = true;
        }
      }
    },
    changeType(e) {
      this.index = e;
      if (this.$route.name == "oemGuardV4") {
        this.companyInfo = {
          companyName: "",
          userName: "",
          userCode: "",
          password: "",
          identityType: 3,
          phoneNumber: "",
        }

        this.$refs.leftRef.validateMethod = 1
        this.$refs.leftRef.isChecked = false
        this.$refs.rightRef.validateMethod = 1
        this.$refs.rightRef.isChecked = false
      } else if (this.$route.name == "oemGuardV4_3") {
        if (e == 1) {
          this.companyInfo.userName = this.infos.taxNo;
        } else {
          this.companyInfo.userName = '';
        }
      } else {
        // 其他路由（如 lvat 的 oauthV2）：切 tab 时直接更新 companyInfo
        // 不能走 receiveMsg，因为 haveload 守卫会拦截
        if (e == 1) {
          // 账密授权：userName = taxNo
          this.companyInfo.userName = this.infos.companyNo;
          delete this.companyInfo.agentTaxNo;
        } else {
          // 扫码/代理授权：agentTaxNo = taxNo，userName 置空（由 QrAuthorize watch 回填）
          this.companyInfo.agentTaxNo = this.infos.companyNo;
          this.companyInfo.userName = '';
        }
      }

    },
  },
};
</script>
<style scoped lang="stylus">
.topselect {
  margin-top: 0px;
  margin: 0.27rem;
  margin-top: 0px;
  margin-left: 0px;
  margin-right: 0px;
  padding-top: 0;
  display: flex;
  border-bottom: 1px solid #E6E8EA;

  > div {
    cursor: pointer;
    font-family: PingFang SC;
    color: #1d2129;
    font-weight: 400;
    font-size: 16px;
    padding-bottom: 8px;
  }

  div.active {
    color: #165dff;
    font-weight: 600;
    font-size: 16px;
    border-bottom: 2px solid #165dff;
  }

  div + div {
    margin-left: 40px;
  }
}

@media screen and (max-width: 768px) {
  .topselect {
    box-sizing: border-box;
    padding-bottom: 0.27rem;
    padding-top: 0;
    margin: 0;
    margin-top: 15px;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    border-bottom: 0px;
    display flex

    .topselect-item:first-child {
      border-radius: 4px 0px 0px 4px;
    }

    .topselect-item {
      margin 0
      text-align: center;
      border: 1px solid #DFDFE0;
      border-left 0
      width: 50%;
      height: .78rem;
      line-height: .78rem;
      flex-grow 1
      border-radius 0;
    }

    .topselect-item:first-child {
      border-left: 1px solid #DFDFE0;
      border-radius 4px 0 0 4px;
    }

    .topselect-item:last-child {
      border-radius 0 4px 4px 0;
    }

    .topselect-item.active {
      border: 1px solid #165DFF;
      border-left 0
      color: white;
      background-color: #165dff;
      font-weight: 400;
    }
  }
}
  .invitationExpiredWrapper{
    height 100vh;
    display flex;
    align-items center
    justify-content center
    .img{
      display block
      width 3.6rem;
      margin 0 auto
    }
    .text-wrapper{
      margin-top 0.3rem;
      .text{
        text-align center
        color: #1D2129;
        font-weight: 600;
        font-size: .32rem;
      }
    }

  }
</style>
